import React, { useState } from "react";
import { ClassesDTO } from "../../interfaces/ClassesDTO";
import { eventBus } from "../../services/eventHandler";
import { RaceDTO } from "../../interfaces/RaceDTO";
import { ViewType } from "../../interfaces/internal/ViewProps";
import { Tooltip } from "react-tooltip";
import "bootstrap/dist/css/bootstrap.min.css";

import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useBlade } from "../../services/BladeProvider";
import { showMenuChoice } from "../../services/menuUpSet";
interface Props {
  race: RaceDTO | null;
  classChanged: (classID: number,level :number,maximized:boolean,fullheight:boolean) => void;
  opennewChanged: (viewdat: ViewType,maximized:boolean,fullheight:boolean) => void;
  onOpenModal: () => void;
  onOpenFile: () => void;
}
const ResultHeader = ({ classChanged, race, opennewChanged,onOpenModal,onOpenFile }: Props) => {
  const [maximized,setMaximized] = useState<boolean>(true);
  const [fullheight,setFullheight] = useState<boolean>(true);
  const { blades, clearBlades,changeBladesizeAll,getUserType,maximizeAllBlade} = useBlade();
    const opentvposClick = (clid: number) => {
    classChanged(clid,1,maximized,fullheight);
    eventBus.emit(`class`, clid);
  };
  
  const maximizedClick = (full:boolean) => {
    setMaximized(full);
    maximizeAllBlade(full);
    // sizeChanged(maximize);
  };
  const heightClick = (full:boolean) => {
    changeBladesizeAll(full)
    setFullheight(full);
  }
  const openNewClick = (typ:ViewType) =>  {
    opennewChanged(typ,maximized,fullheight);
  }
  const closeAllClick = () => {
    clearBlades(true);
    // sizeChanged(maximize);
  };


  const usrType = getUserType();
if (usrType == null){
  return <></>
}

  return (
    <>
      <div className="result-header-loggo">&nbsp;</div>
      <div className="result-header-menu">
      <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn- btn-light"
                style={{height: "31px",paddingTop: "4px"}}
              >
                Menu
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item id="addlist" onClick={() => openNewClick(ViewType.result)}>Add list</Dropdown.Item>
                {usrType.valueOf() < 31 ? (<Dropdown.Item id="addlistpre" onClick={() => openNewClick(ViewType.resultPretime)}>Add list with pretime</Dropdown.Item>) : null}
                {showMenuChoice(race,ViewType.scroll) ? <Dropdown.Item id="addscroll" onClick={() => openNewClick(ViewType.scroll)}>Add scroll</Dropdown.Item> : null}
                <Dropdown.Item id="addbios" onClick={() => openNewClick(ViewType.athletebio)}>Add bios</Dropdown.Item>
                {usrType.valueOf() < 5 ? <Dropdown.Item id="addbiosTV" onClick={() => openNewClick(ViewType.athletebioTV)}>Add bios auto follow(TV)</Dropdown.Item> : null }
                {showMenuChoice(race,ViewType.shooting) ? <Dropdown.Item id="addshooting" onClick={() => openNewClick(ViewType.shooting)}>Add shooting</Dropdown.Item> : null}
                { <Dropdown.Item id="addsprint" onClick={() => openNewClick(ViewType.stage)}>Add sprint bracket</Dropdown.Item>}
                {/* {showMenuChoice(race,ViewType.stage) ? <Dropdown.Item id="addsprint" onClick={() => openNewClick(ViewType.stage)}>Add sprint bracket</Dropdown.Item> : null} */}
                {usrType.valueOf() < 31 ? <Dropdown.Item id="addanalys" onClick={() => openNewClick(ViewType.resultAnalytics)}>Add analyslist</Dropdown.Item> : null }
                <Dropdown.Item id="addteaminfo" onClick={() => openNewClick(ViewType.teamdata)}>Add teamdata</Dropdown.Item>
                {/* <Dropdown.Item id="addCourseMap" onClick={() => openNewClick(ViewType.coursemap)}>Add map</Dropdown.Item> */}
                <Dropdown.Item id="addSpeakerView" onClick={() => openNewClick(ViewType.speakerView)}>Add speakerview</Dropdown.Item>
                <Dropdown.Divider />    
                <Dropdown.Item onClick={closeAllClick}>Close all</Dropdown.Item>            
                <Dropdown.Item onClick={() => onOpenModal()}>Change usertype</Dropdown.Item>            
                <Dropdown.Item onClick={() => onOpenFile()}>Upload File</Dropdown.Item>            
                {/* <Dropdown.Item>Minimize all</Dropdown.Item>   */}
                <Dropdown.Divider />             
                <Dropdown.Item href="/" >Home</Dropdown.Item>            
              </Dropdown.Menu>
            </Dropdown>
            <Tooltip
            anchorSelect="#addlist"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a blade with results or startlist
          </Tooltip>
          <Tooltip
            anchorSelect="#addlistpre"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a blade with results or startlist, and pretimes 
          </Tooltip>
          <Tooltip
            anchorSelect="#addscroll"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a blade with scroll sort 
          </Tooltip>
          <Tooltip
            anchorSelect="#addbios"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a bios blade with athletes info and race data 
          </Tooltip>
          <Tooltip
            anchorSelect="#addbiosTV"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a bios blade with athletes info and race <br /> data updates automatic from graphic 
          </Tooltip>
          <Tooltip
            anchorSelect="#addshooting"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds shooting range with targets 
          </Tooltip>
          <Tooltip
            anchorSelect="#addsprint"
            place="right"
            style={{ zIndex: 999 }}
          >
            Adds a sprint stage 
          </Tooltip>
      </div>
      <div className="result-header-menu-classes" id="header-menu-classes">
        {race?.Class && usrType.valueOf() < 31  &&
          Object.keys(race?.Class).map((key) => (
            <button
              key={key}
              data-class={key}
              className="result-header-menu-classes-buttons"
              onClick={() => opentvposClick(parseInt(key))}
            >
              {race?.Class[parseInt(key)].Name}
            </button>
          ))}
      </div>
      <div className="result-header-right-button">
       <div
          className="result-header-right-menu-button result-header-menu-button-minimized"
          id="view-minimized"
          onClick={() => maximizedClick(false)}
        >
          &nbsp;
        </div> 
        <div
          className="result-header-right-menu-button result-header-menu-button-maximized"
          id="view-minimized"
          onClick={() => maximizedClick(true)}
        >
          &nbsp;
        </div> 
        <div
          className="result-header-right-menu-button result-header-menu-button-half-height"
          id="view-half"
          onClick={() => heightClick(false) }
        >
          &nbsp;
        </div>
        <Tooltip
            anchorSelect="#view-half"
            place="bottom"
            style={{ zIndex: 999 }}
          >
            Makes all blades to half height 
          </Tooltip>
        <div
          className="result-header-right-menu-button result-header-menu-button-full-height"
          id="view-full"
          onClick={() => heightClick(true) }
        >
          &nbsp;
        </div>
        <Tooltip
            anchorSelect="#view-full"
            place="bottom"
            style={{ zIndex: 999 }}
          >
            Makes all blades to full height 
          </Tooltip>
      </div>
      <div className="result-header-text">
        <span id="event-name" className="result-header-event-name">
          {race?.Name}
        </span>
        <span id="event-place" className="result-header-event-place">
          {race?.Place}
        </span>
      </div>
      <div className="result-header-settings">
        <div className="result-header-settings-button" id="menu-settings">
          &nbsp;
        </div>
      </div>
    </>
  );
};
export default ResultHeader;
